// import { logger } from '@/helpers';
import { defineComponent ,onMounted,ref } from 'vue'
import { useRouter } from "vue-router";

import LogoSmall from "@/components/LogoSmall/LogoSmall.vue";
// import PopupTerm from "@/components/PopupTerm/PopupTerm.vue";

import { useStore } from "vuex";
import {  useReCaptcha } from 'vue-recaptcha-v3'
import {  ApiService } from '@/api/api';
import { useGtag } from "vue-gtag-next";

// import { gsap } from "gsap";

//type
import { TypeCard } from '@/types/Card'

export default defineComponent({
  // type inference enabled

  components:{
    LogoSmall,
    // PopupTerm
  },
  setup() {
    const router = useRouter();
    const btActive = ref(false);
    const store = useStore();
    const { pageview,event } = useGtag();

    // console.log(store.state.logs)
    const reCaptcha = useReCaptcha();

    
    const SelectCard = (e:Event) =>{
      event('click', { 'event_category' : 'selectcard',    })
      btActive.value =true;

      const target = (<HTMLInputElement>e.target)
      
      const list = document.getElementsByClassName("card-image");
      for (const item of list) {
          item.classList.remove("active");
        }
      target.classList.add("active");

    }
    

    const StartPlay = async () =>{
      // eslint-disable-next-line
      (window as any).fbq('track', 'OpenCard') 

      await reCaptcha?.recaptchaLoaded();

      const token = await reCaptcha?.executeRecaptcha('submit');
      const RequestParam = {
        "siteresponse": token,
      }


      const RequestResp = await ApiService.PickCard(RequestParam)
      const {data}  = RequestResp 
      
      event('apirequest', { 'event_category' : 'pickcard',    })

      const CardData = <TypeCard>{
        cardid:data.cardid,
        cardtype:data.cardtype,
        registerid:data.registerid,
        // cardid:'C07',
        // cardtype: 'Golden',
        // registerid: 'xxx'
      }


       store.dispatch('Card/SetCard',CardData)

      // store.dispatch('logs/SetDeviceID',DeviceID)
     
      // console.log("StartPlay")
      router.push('/Result')
    }

    onMounted(() => {
      pageview({ page_path: "/Play" });

      const list = document.getElementsByClassName("card-image");
      for (const item of list) {
          item.classList.remove("active");
      }

      // check allowed consent
      if(!localStorage.getItem("allow_cookie") ) return router.push('/')
    })

    return {btActive,StartPlay,SelectCard}
  

  },
 
})
